<div class="card mb-0">
  <div class="flex justify-between mb-2">
    <div>
      <span class="block text-gray-700 dark:text-gray-100 font-medium mb-2"
        >Alarmes Actives (Total)
      </span>
      <div class="text-surface-700 dark:text-surface-0 font-bold text-xl">
        <span *ngIf="!loading">{{ alarmCount }}</span>
        <p-skeleton *ngIf="loading" width="4rem" height="2rem"></p-skeleton>
      </div>
    </div>
    <div
      class="flex items-center justify-center bg-red-100/70 rounded-full"
      [ngStyle]="{ width: '2.5rem', height: '2.5rem' }"
    >
      <i class="pi pi-bell text-red-500/80 text-xl"></i>
    </div>
  </div>
  <span class="font-medium mb-4 text-red-500">
    <span *ngIf="!loading">+ {{ activeAlarmsFromYesterday }} depuis hier</span>
    <p-skeleton *ngIf="loading" width="8rem" height="1rem"></p-skeleton>
  </span>
</div>
